import { useThirdPartyState } from '../ThirdParty';

export interface InfiSpotlightState {
	isLoading: boolean;
	isEnabled: boolean;
}

export const useInfiSpotlight = (): InfiSpotlightState => useThirdPartyState().infiSpotlight;
